<template>
  <div>
    <!-- <beautiful-chat
      :participants="participants"
      :onMessageWasSent="onMessageWasSent"
      :messageList="messageList"
      :isOpen="isChatOpen"
      :close="closeChat"
      :open="openChat"
      :showEmoji="false"
      :showFile="false"
      :showEdition="false"
      :showDeletion="false"
      :showTypingIndicator="showTypingIndicator"
      :showLauncher="true"
      :showCloseButton="true"
      :colors="colors"
      :alwaysScrollToBottom="alwaysScrollToBottom"
      :messageStyling="messageStyling"
      placeholder="Please enter the content" >
        <template v-slot:user-avatar="{ message }">
          <div v-if="message.type == 'file' ">
             <span v-if="message.data.type == '.mp4' ">
               <video style="width: 100px;height: 100px;" :src="message.data.file.url" controls loop></video>
             </span> 
             <span v-if="message.data.type == '.jpg' || message.data.type == '.png' || message.data.type == '.jpeg' || message.data.type == '.gif' ">
               <img style="width: 100%;height: 100px;" :src="message.data.file.url" @click="handleClickImg(message.data.file.url)" />
             </span> 
          </div>
        </template>
      </beautiful-chat> -->


      <model-Components v-if="ShowbaseCat" :messageList="messageList" :row="row" @closeChatEvent="closeChatEvent" @handleClickImgEvent="handleClickImgEvent"></model-Components>



    <!-- <div style="display: none;">
      <el-upload
          class="avatar-uploader"
          ref="upload"
          action="#"
          :on-remove="handleRemove"
          :beforeUpload="beforeUpload"
          :file-list="fileLists"
          :http-request="handleUpload"
          :on-error="handleError"
          :auto-upload="true"
          drag>
      </el-upload>
    </div> -->


    <el-dialog title="上传"  :visible.sync="dialogShow"  width="50%"  :before-close="handleShowClose">
       <el-upload
          class="avatar-uploader"
          ref="upload"
          action="#"
          :on-remove="handleRemove"
          :beforeUpload="beforeUpload"
          :file-list="fileLists"
          :http-request="handleUpload"
          :on-error="handleError"
          :auto-upload="true"
          show-file-list
          :limit="100"
          drag>
          <i class="el-icon-plus" style="font-size: 50px; line-height: 160px;"></i>


       </el-upload>

       <div  class="dialog-footer" style=" padding-bottom: 30px; margin-top: 90px;">
            <el-button @click="handlescreenshotCler" style="margin-right: 50px;">取 消</el-button>
            <el-button type="primary" @click="handlescreenshotSubmit">确 定</el-button>
       </div>

     </el-dialog>




    <audio :controls="false" id="musicAudio">
      <!-- <source src="https://mz-app-develop.oss-cn-beijing.aliyuncs.com/wx_imgs/images/wumingderen.mp3" type="audio/mpeg"> -->
      <source src="./RatherBe.mp3" type="audio/mpeg">
        您的浏览器不支持 audio 元素。
    </audio>

    <el-tooltip class="item" effect="light" content="上传资料" placement="top-start">
      <div class="pulling animate__animated animate__fadeInUp" @click="handlePullingPu">+</div>
    </el-tooltip>


    <div class="animate__animated animate__fadeInUp btn_chehui">
      <el-tooltip class="item" effect="light" content="消息列表" placement="top-start">
        <el-button  circle class="btns"  icon="el-icon-delete"   @click="handleMessageClick"></el-button>
      </el-tooltip>
    </div>

    <el-dialog  title="撤回消息" :visible.sync="dialogMessage" width="80%" :before-close="handleClose">
      <div style="height: 60vh;overflow-y: auto;"  v-if="dialogMessageList.length > 0">
        <el-tag
           v-for="(tag,index) in dialogMessageList"
           :key="index" type closable
           @close="handleDele(tag)">
           {{tag.data.text}}
        </el-tag>
      </div>
      <div v-else style="height: 60vh;overflow-y: auto;">
          <el-empty style="margin-top: 117px;" description="暂无聊天消息"></el-empty>
      </div>

    </el-dialog>


    <div style="display: flex;  position: fixed;width: 77%; bottom: 10px;margin-left: 13px;height: 50px;">
            <el-input style="padding: 10rpx 0rpx;" :autosize="{ minRows: 2, maxRows: 2}"
             v-model="inputValue" type="textarea" placeholder="请输入消息">
            </el-input>

            <el-button @click="handleClickMessage"
             style="background-color: rgb(78, 140, 255);color: #fff;height: 55px;"
             icon="el-icon-position"></el-button>
    </div>

    <el-dialog  :visible.sync="showUrlDialog" :before-close="handleshowUrlDialogClose">
       <div>
          <img :src="showUrl" alt="" style="width: 100%;height: 100%;">
       </div>
    </el-dialog>


  </div>
</template>

<script>
import { put, signatureUrl, getFileNameUUID } from "../../utils/oss";
import loadingUtils from "../../utils/loading";
import 'animate.css'
import {  ApiSendMessage, ApiDeleteMessage, ApiChatList } from "@/api/weekendReminder"


export default {
  name: "chatDetailQA",
  props:{
    row:{
      default: () => {},
      type: Object
    }
  },
  data() {
    return {
      participants: [ { id: "user1", name: "张老师" }],
      messageList: [
        // { type: "text", author: `me`, data: { text: `你好` } },
        // { type: "text", author: `user1`, data: { text: `No.` } },
      ],
      isChatOpen: true,
      showTypingIndicator: "",
      colors: {
        header: {
          bg: "#4e8cff",
          text: "#ffffff",
        },
        launcher: {
          bg: "#4e8cff",
        },
        messageList: {
          bg: "#ffffff",
        },
        sentMessage: {
          bg: "#4e8cff",
          text: "#ffffff",
        },
        receivedMessage: {
          bg: "#eaeaea",
          text: "#222222",
        },
        userInput: {
          bg: "#f4f7f9",
          text: "#565867",
        },
      },
      alwaysScrollToBottom: true,
      messageStyling: true,

      screenshot:"",
      fileLists:[],

      audios:null,

      dialogMessage:false,
      dialogMessageList:[],

      // row:null,
      msgContext:null,
      msg:null,


      isShowMessage:false,

      inputValue:"",

      dialogShow:false,
      url:"",
      name:"",

      showUrl:"",
      showUrlDialog:false,

      fileListsPush:[],

      ShowbaseCat:true,

    };
  },
  created() {

  },

  mounted(){

    // let opened = document.getElementsByClassName('sc-launcher')[0]
    // opened.style.display = 'none'

    // let window = document.getElementsByClassName('sc-chat-window')[0]
    // window.style.width = '80%'
    // window.style.top = '150px'
    // window.style.left = '270px'
    // window.style.position = ''

    // let input = document.getElementsByClassName('sc-user-input--text')[0]
    // input.style.width = '90%'
    // input.addEventListener('input',(event)=>{
    //   if(event){
    //      this.isShowMessage = true
    //    }
    // })


    // let userinput = document.getElementsByClassName('sc-user-input')[0]
    // userinput.style.display = 'none'

    // this.row = this.$route.query.row
    // this.row ? this.handleInitializeChat(this.row) : console.log('初始化失败')
    


    this.row = this.row
    this.row ? this.handleInitializeChat(this.row) : console.log('初始化失败')



    this.handleTimingMessage()

  },

  methods: {

    handleClickImg(url){
      if(url){
        this.showUrlDialog = true
        this.showUrl = url
      }
    },
    handleClickImgEvent(url){
      if(url){
        this.showUrlDialog = true
        this.showUrl = url
      }
    }, 

    handleshowUrlDialogClose(){
      this.showUrlDialog = false
      this.showUrl = ""
    },

    handleMessageFileImg(){
      this.$nextTick(()=>{

        // let messageFileImg = document.querySelectorAll('.sc-message--file-icon')
        //     messageFileImg.forEach(function(element) {
        //       element.style.display = 'none'
        //       element.style.padding = '10px'
        //     });

        // let messageImage = document.querySelectorAll('.sc-image')
        //     messageImage.forEach(function(element) {
        //       // element.style.width = '200px'
        //     });

        // let messageFileText = document.querySelectorAll('.sc-message--file-text')
        //     messageFileText.forEach(function(element) {
        //       // element.style.display = 'none'
        //     });

        // let messageFileName = document.querySelectorAll('.sc-message--file-name')
        //     messageFileName.forEach(function(element) {
        //       element.style.padding = '15px'
        //       element.style.borderRadius = '10px'
        //     });

      })

    },

    handleClose(){
      this.dialogMessage = false
    },


    handleShowClose(){
      this.fileLists = [];
      this.fileListsPush = []
      this.dialogShow = false
    },

    handlescreenshotCler(){
      this.fileLists = [];
      this.fileListsPush = []
      this.dialogShow = false
    },
    
    handlescreenshotSubmit(){
      if(this.fileListsPush.length > 0){
        this.fileListsPush.map((itme)=>{
          this.handleApiSendMessage(itme.url, itme.name)
        })
        this.handleShowClose()
      }else{
        this.$message({
          showClose: true,
          message: '请选择文件',
          type: 'warning'
        });
      }
    },


    handleMessageClick(){

      this.dialogMessageList = this.messageList.filter((itme)=>{
          return itme.author == 'me'
      })

      this.dialogMessage = true
    },

    handlePullingPu(){
      // this.$refs["upload"].$refs["upload-inner"].handleClick()
      this.dialogShow = true
    },

    handleTopScroll(){
       this.$nextTick(() => {
          this.$refs.chat.scrollTop  = this.$refs.chat.scrollHeight;
       });
    },

    handleDele(e){
      let { id } = e
      ApiDeleteMessage(id).then((res)=>{
        if(res.code == 200){
            this.$message({type: 'success',message: '删除成功'});
            this.handleRendering()

        }else{
            this.$message({type: 'error',message: '删除失败'});
        }
      })
    },

    handleFormatType(name){
      //  return name.substring(name.lastIndexOf("."));
      return name.slice(-3)
    },

    handleRendering(){
      this.isShowMessage = false
      let data = { msgId: this.msg.msgId.toString() }
      ApiChatList(data).then((res) => {
        this.messageList = []
        if(res.code == 200){
          res.data.map((itme)=>{
            let isBoole = this.handleFormatType(itme.contextInfo)
            if(itme.msgSender == 2){
              let file = { name: itme.remark, url: itme.contextInfo }
              if(itme.remark){
                this.onMessageWasSent({ chatState:itme.chatState, id: itme.contextId, author: "me", type: 'file', data: { file: file, text: itme.createTime, type: this.handleFormatType(itme.contextInfo)}});
              }else{
                this.onMessageWasSent({ chatState:itme.chatState, id: itme.contextId, author: "me", type: 'text', data: { text: itme.contextInfo, meta: itme.createTime }});
              }
            }else{
              let file = { name: itme.remark, url: itme.contextInfo }
              if(itme.remark){
                this.onMessageWasSent({ chatState:itme.chatState, id: itme.contextId, author: "user1", type: 'file', data: { file: file, text: itme.createTime, type: this.handleFormatType(itme.contextInfo)}});
              }else{
                if(isBoole === 'png' || isBoole === 'mp4' || isBoole === 'gif' || isBoole === 'jpg'){
                  this.onMessageWasSent({ chatState:itme.chatState, id: itme.contextId, author: "user1", type: 'file', data: { file: file, text: itme.createTime, type: this.handleFormatType(itme.contextInfo)}});
                }else{
                  this.onMessageWasSent({ chatState:itme.chatState, id: itme.contextId, author: "user1", type: 'text', data: { text: itme.contextInfo, meta: itme.createTime }});
                }
              }
            }
          })

          this.dialogMessageList = this.messageList.filter((itme)=>{
             return itme.author == 'me'
          })
        }
      })
    },

    handleMusic(){
      if(this.audios){}else{
         this.audios = document.getElementById('musicAudio');
         this.audios.play()
      }
    },


    handleApiSendMessage(parame,remark = ''){
      let data = { msgId: this.msg.msgId.toString(),msgSender: 2,contextInfo: parame , remark}
      ApiSendMessage(data).then((res)=>{
          this.isShowMessage = false
          this.inputValue = ""
          this.handleRendering()
      })
    },


    handleClickMessage(){
      if(this.inputValue){
         this.isShowMessage = true
         this.onMessageWasSent(this.inputValue)
         
         let boxElement = document.getElementById('overflowTop');
         boxElement.scrollTop = boxElement.scrollHeight - boxElement.clientHeight;

      }else{
         this.$message({type: 'warning',message: '请输入发送内容'});
      }
    },

    onMessageWasSent(message) {
      // this.handleMusic()


      if(this.isShowMessage){
         this.handleApiSendMessage(message)
      }else{
         this.messageList = [...this.messageList, message];
      }

      this.handleMessageFileImg()

    },

    handleFileName(filename){
      const lastDot = filename.lastIndexOf('/');
      if (lastDot !== -1 && lastDot !== 0) {
         return filename.slice(lastDot + 1)
      }
    },

    openChat() {
      this.isChatOpen = true;
    },

    closeChat() {
      // this.$router.go(-1);
      this.$emit('showChatDetailEvent', false)
    },

    closeChatEvent(event){
      this.ShowbaseCat = false
      this.$emit('showChatDetailEvent', event)
    },

    handleInitializeChat(infoInstall){
      let { msg, msgContext, teacher, student, subject} = infoInstall

      this.msg = msg
      
      this.participants[0].name = `${teacher.realname}-${student.realname}-${subject.categoryName}` 

      this.msgContext = msgContext

      this.handleRendering()

    },


    handleTimingMessage(){
      this.isShowMessage = false
      this.setTime =  setInterval(()=>{
          let data = { msgId:this.msg.msgId.toString() }
          ApiChatList(data).then((res) => {
            if(res.code == 200){
              this.messageList = []
              res.data.map((itme)=>{
                let isBoole = this.handleFormatType(itme.contextInfo)
                if(itme.msgSender == 2){
                  let file = { name: itme.remark, url: itme.contextInfo }
                  if(itme.remark){
                    this.onMessageWasSent({ chatState:itme.chatState, id: itme.contextId, author: "me", type: 'file', data: { file: file, text: itme.createTime, type: this.handleFormatType(itme.contextInfo)}});
                  }else{
                    this.onMessageWasSent({ chatState:itme.chatState, id: itme.contextId, author: "me", type: 'text', data: { text: itme.contextInfo, meta: itme.createTime }});
                  }
                }else{
                  let file = { name: itme.remark, url: itme.contextInfo }
                  if(itme.remark){
                    this.onMessageWasSent({ chatState:itme.chatState, id: itme.contextId, author: "user1", type: 'file', data: { file: file, text: itme.createTime, type: this.handleFormatType(itme.contextInfo)}});
                  }else{
                    // this.onMessageWasSent({ chatState:itme.chatState, id: itme.contextId, author: "user1", type: 'text', data: { text: itme.contextInfo, meta: itme.createTime }});
                    if(isBoole === 'png' || isBoole === 'mp4' || isBoole === 'gif' || isBoole === 'jpg'){
                      this.onMessageWasSent({ chatState:itme.chatState, id: itme.contextId, author: "user1", type: 'file', data: { file: file, text: itme.createTime, type: this.handleFormatType(itme.contextInfo)}});
                    }else{
                      this.onMessageWasSent({ chatState:itme.chatState, id: itme.contextId, author: "user1", type: 'text', data: { text: itme.contextInfo, meta: itme.createTime }});
                    }
                  }
                }

              })
            }
          })
      },3000)
    },





    // =============================================================上传文件===============================================================>>>>>
    getFileName(name) {
      return name.substring(name.lastIndexOf("."));
    },

    beforeUpload(file) {
      loadingUtils.startLoading()
      const fileExtensions =
        this.getFileName(file.name) === ".bmp" ||
        this.getFileName(file.name) === ".tif" ||
        this.getFileName(file.name) === ".gif" ||
        this.getFileName(file.name) === ".pcx" ||
        this.getFileName(file.name) === ".svg" ||
        this.getFileName(file.name) === ".psd" ||
        this.getFileName(file.name) === ".webp" ||
        this.getFileName(file.name) === ".apng" ||
        this.getFileName(file.name) === ".ai" ||
        this.getFileName(file.name) === ".avif" ||
        this.getFileName(file.name) === ".png" ||
        this.getFileName(file.name) === ".pdf"||
        this.getFileName(file.name) === ".mp4"||
        this.getFileName(file.name) === ".excel"||
        this.getFileName(file.name) === ".doc"||
        this.getFileName(file.name) === ".ppt"||
        this.getFileName(file.name) === ".mp3"||
        this.getFileName(file.name) === ".xls"||
        this.getFileName(file.name) === ".xlsx"||
        this.getFileName(file.name) === ".pptx"||
        this.getFileName(file.name) === ".docx"||
        this.getFileName(file.name) === ".txt"||
        this.getFileName(file.name) === ".jpg";
      const max20M = file.size / 1024 / 1024 < 1000;
      if (!fileExtensions) {
        this.$message.error("上传文件类不合格式!");
        loadingUtils.endLoading();
      }
      if (!max20M) {
        this.$message.error("上传文件大小不能超过 1000MB!");
        loadingUtils.endLoading();
      }
      this.fileLists.push(file);
      return fileExtensions && max20M;
    },
    handleUpload(option) {
      var obj = option.file.name;
      var index = obj.lastIndexOf(".");
      obj = obj.substring(index, obj.length);
      let objName = getFileNameUUID() + this.getFileName(option.file.name);
      put(`mz_pc/${objName}`, option.file).then((res) => {

       // this.handleApiSendMessage(res.url, option.file.name)

        let file = { url: res.url,name: option.file.name }
        this.fileListsPush.push(file)

        loadingUtils.endLoading();
        this.screenshot = res.url
        signatureUrl(`mz_pc/${objName}`).then((res) => {

        });
      });
    },
    handleRemove(file, fileList) {
      this.fileLists = fileList;


      this.fileListsPush = this.fileListsPush.filter((itme)=>{
        return itme.name !== fileList[0].name
      })

      this.screenshot = ""
    },

    handleError(){
      loadingUtils.endLoading();
    },


  },

  beforeDestroy(){
    clearInterval(this.setTime)
  }

};
</script>


<style scoped>

@media screen and (min-width: 1651px) and (max-width: 2200px) {
  .pulling{
    width: 50px;
    height: 50px;
    background: rgb(78, 140, 255);
    color: #fff;
    position: absolute;
    border-radius: 50%;
    line-height: 48px;
    font-size: 43px;
    bottom: 70px;
    right: 120px;
  }
  .btn_chehui{
    position: absolute;
    bottom: 70px;
    right: 180px;
  }
}


@media screen and (min-width: 1400px) and (max-width: 1650px) {
  .pulling{
    width: 50px;
    height: 50px;
    background: rgb(78, 140, 255);
    color: #fff;
    position: absolute;
    border-radius: 50%;
    line-height: 48px;
    font-size: 43px;
    bottom: 80px;
    right: 70px;
  }
  .btn_chehui{
    position: absolute;
    bottom: 80px;
    right: 130px;
  }
}

@media screen and (min-width: 1200px) and (max-width: 1400px) {
  .pulling{
    width: 50px;
    height: 50px;
    background: rgb(78, 140, 255);
    color: #fff;
    position: absolute;
    border-radius: 50%;
    line-height: 48px;
    font-size: 43px;
    bottom: 80px;
    right: 40px;
  }
  .btn_chehui{
    position: absolute;
    bottom: 80px;
    right: 100px;
  }
}

@media screen and (min-width: 300px) and (max-width: 1199px) {
  .pulling{
    width: 50px;
    height: 50px;
    background: rgb(78, 140, 255);
    color: #fff;
    position: absolute;
    border-radius: 50%;
    line-height: 48px;
    font-size: 43px;
    bottom: 80px;
    right: 40px;
  }
  .btn_chehui{
    position: absolute;
    bottom: 80px;
    right: 100px;
  }
}

.btns{
  background-color: rgb(78, 140, 255);
  border-color: rgb(78, 140, 255);
  color: #fff;
}


.el-tag{
  margin-bottom: 10px;
  display: block;
}
/* .el-tag[data-v-50f6e086]{
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
} */


.view-contain-ti {
    display: flex;
    height: 110rpx;
    border: 3rpx solid #faca82;
    border-radius: 10rpx;
  }

  .text-ti {
    position: absolute;
    font-size: 24rpx;
    background: white;
    margin: -20rpx 0 0 20rpx;
    padding: 0 10rpx;
    color: rgb(144, 147, 167);
  }

  .input1 {
    margin:  auto 20rpx;
  }


</style>



// WEBPACK FOOTER //
// src/manager/afterSales/chatDetailQA.vue